/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Support_Items1Inputs */

const vi_sitesettings_home_support_items1 = /** @type {(inputs: Sitesettings_Home_Support_Items1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ mua hàng`)
};

/**

* @param {Sitesettings_Home_Support_Items1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_support_items1 = /** @type {((inputs?: Sitesettings_Home_Support_Items1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Support_Items1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_support_items1(inputs)
});
export { sitesettings_home_support_items1 as "siteSettings_home_support_items" }